import { StyleSheet } from "react-native";

const style = StyleSheet.create({
  spinnerWrapper: {
    alignItems: "center",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "center",
    width: "100%",
  },
});

export { style };
